<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div class="row mt-4">
      <h4 class="mt-4 col-12">Profil de {{username}}</h4>
    </div>
    <div class="row mt-4">
      <div class="col-md-4 text-center">
        <img v-bind:src="user.picture" width="256" v-if="user.picture"/>
        <img src="../../assets/default-profile.png" v-else width="256"/>
        <br />
        <button type="button"
            class="btn btn-link"
            @click="changePicture()">Changer de photo</button>
      </div>
      <div class="col-md-8 col-lg-6">
        <form v-if="changeUsername">
          <div class="form-group">
            <label for="usernameField">
              Votre nom dans le jeu de Scrabble Lettre Compte Triple:</label>
            <input type="text" class="form-control" maxlength="35"
            id="usernameField"
            aria-describedby="usernameHelp"
            v-model="username">
            <small id="usernameHelp" class="form-text text-muted">
              Les termes injurieux sont à proscrire !<br />
              Vous pourrez changer de nom ultérieurement.
            </small>
          </div>
          <div class="row justify-content-md-center">
            <button type="button"
            class="btn btn-primary"
            @click="updateUserName(username)"
            :disabled="!username">Valider</button>
          </div>
        </form>
        <div v-else>
          <label>
              Votre nom dans le jeu de Scrabble Lettre Compte Triple:</label>
          <div>{{username}}
           <button type="button"
            class="btn btn-link"
            @click="changeUsername = !changeUsername">Changer</button>
          </div>
        </div>
      </div>
     </div>
     <div lass="row mt-4" v-if="isPremiumOrAdmin && games.length > 0">
       <div class="col-12">
          <ProfileCharts v-bind:games="games"/>
        </div>
     </div>
     <div class="row mt-4">
      <div class="col-12 col-md-4 player-list">
        <h4>Vos amis</h4>
        <ul class="list-group list-group-flush" v-if="friends">
          <li v-for="player in friends" v-bind:key="player.userId" class="list-group-item">
            <Player v-bind:username="player.username"
            v-bind:userId="player.userId"
            v-bind:picture="player.picture"
            v-on:refresh-list="refreshUser"/>
          </li>
        </ul>
      </div>
      <div class="col-12 col-md-8">
        <user-game-list v-if="games.length > 0"
          v-bind:games="games"/>
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import iam from '../../iam';
import LoggedUser from '../LoggedUser';
import BottomNav from '../BottomNav';
import ChangePicture from './ChangePicture';
import UserGameList from './UserGameList';
import Player from '../Player';
import ProfileCharts from './ProfileCharts';

export default {
  name: 'Profile',
  data() {
    return {
      loading: true,
      user: iam.getConnectedUser(),
      isPremiumOrAdmin: iam.isPremiumOrAdmin(),
      friends: iam.getConnectedUser().friends,
      changeUsername: false,
      username: iam.getConnectedUser().username,
      games: [],
    };
  },
  components: { LoggedUser, BottomNav, ChangePicture, UserGameList, Player, ProfileCharts },
  async created() {
    this.games = await this.getGames();
  },
  methods: {
    updateUserName(username) {
      return this.$http.post(`${process.env.LCT_API_URL}/users`, {
        username,
        picture: this.user.picture,
      }).then((response) => {
        this.user.username = response.data.username;
        iam.setConnectedUser(this.user);
        this.changeUsername = false;
      });
    },
    changePicture() {
      this.$router.push('/picture');
    },
    refreshUser() {
      this.friends = iam.getConnectedUser().friends;
    },
    async getGames() {
      const url = this.userId
        ? `${process.env.LCT_API_URL}/ended-games-players/${this.userId}`
        : `${process.env.LCT_API_URL}/ended-games-players/me`;
      return this.$http.get(url).then(response => response
        .data.sort((a, b) => a.createdAt - b.createdAt));
    },
  },
};
</script>

<style scoped>
.btn-link{
  color: #CE0F69;
}
.player-list{
  z-index: 1;
}
.player-list ul{
  list-style-type: none;
  margin: 4px 0 0 0;
}
.player-list ul .list-group-item {
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/Profile.vue